/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Forward_EmailInputs */

const en_dashboard_forward_email = /** @type {(inputs: Dashboard_Forward_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward an Email`)
};

const es_dashboard_forward_email = /** @type {(inputs: Dashboard_Forward_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar un correo`)
};

/**
* | output |
* | --- |
* | "Forward an Email" |
*
* @param {Dashboard_Forward_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_forward_email = /** @type {((inputs?: Dashboard_Forward_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Forward_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_forward_email(inputs)
	return en_dashboard_forward_email(inputs)
});